/**
 * ResumeMetric - STAR Method Builder
 * Guided template engine for behavioral interview answers.
 * @module tools/starBuilder
 */

export function buildSTARResponse(input) {
    const { situation, task, action, result, role, company } = input;

    const sections = [];
    const missing = [];

    if (situation && situation.trim()) {
        sections.push({ label: 'Situation', text: situation.trim() });
    } else {
        missing.push('Situation');
    }

    if (task && task.trim()) {
        sections.push({ label: 'Task', text: task.trim() });
    } else {
        missing.push('Task');
    }

    if (action && action.trim()) {
        sections.push({ label: 'Action', text: action.trim() });
    } else {
        missing.push('Action');
    }

    if (result && result.trim()) {
        sections.push({ label: 'Result', text: result.trim() });
    } else {
        missing.push('Result');
    }

    if (sections.length === 0) return null;

    // Build formatted response
    const contextPrefix = (role && company) ? `In my role as ${role} at ${company}, ` :
                          role ? `As a ${role}, ` :
                          company ? `At ${company}, ` : '';

    const formatted = sections.map(s => s.text).join(' ');
    const fullResponse = contextPrefix + formatted;

    const wordCount = fullResponse.trim().split(/\s+/).filter(Boolean).length;
    const readingTime = Math.ceil(wordCount / 150); // speaking pace ~150 WPM

    return {
        sections,
        missing,
        isComplete: missing.length === 0,
        formatted: fullResponse,
        wordCount,
        speakingTime: readingTime,
        idealLength: wordCount >= 100 && wordCount <= 250
    };
}
